import { Component } from "@angular/core";
import { tradeDeskTabsParams } from './tradedeskTabs.list';
import { MainUIServiceService } from "../../services/main-uiservice.service";

@Component({
    selector: "tradedesk-tabs",
    template: require('./tradedeskTabs.component.html'),
    styles: [
        require('../quotePanelTabs/quotePanelTabs.component.css'),require('./tradeskTabs.component.scss')
    ]
})

export class tradeDeskTabs {
    
    private _activeTabId:string = "_orders";
    tabs: object= tradeDeskTabsParams();

    constructor(protected mainUIService:MainUIServiceService )
    {}

    get activeTab(): string {
        return this._activeTabId;
    }

    set activeTab(tabId: string) {

        this._activeTabId = tabId;
        this.mainUIService.TabsActive.next(this._activeTabId);
    }

}